import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { textRange, uuid } from '@/utils/util';
import { nextTick, reactive, useAttrs } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const attrs = useAttrs();
    const state = reactive({
      isShowTip: false,
      uuid: uuid()
    });
    const handleMouseOver = () => {
      nextTick(() => {
        const target = state.uuid;
        state.isShowTip = !textRange(target);
      });
    };
    return (_ctx, _cache) => {
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      return _openBlock(), _createBlock(_component_el_tooltip, _mergeProps({
        disabled: state.isShowTip,
        content: _unref(attrs).content
      }, _unref(attrs)), {
        default: _withCtx(() => [_createElementVNode("span", {
          ref: state.uuid,
          class: _normalizeClass(['target-con', _unref(attrs).className]),
          style: _normalizeStyle({
            width: _unref(attrs).width + 'px'
          }),
          onMouseover: handleMouseOver
        }, _toDisplayString(_ctx.$attrs.content), 39)]),
        _: 1
      }, 16, ["disabled", "content"]);
    };
  }
});